// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import Logo from "../imgs/top-sito.jpg";
// import DLogo from "../imgs/dropdown-icon.png";
// import Facebook from "../facebook.svg";
// import Youtube from "../youtube.svg";

// const Navbar = () => {
//   const [sidenavOpen, setSidenavOpen] = useState(false);
//   const toggleSidenav = () => {
//     setSidenavOpen(!sidenavOpen);
//   };

//   return (
//     <div className="flex flex-col items-center">
//       <img src={Logo} alt="Logo" />

//       <nav className="xs:hidden xl:inline-block text-xl h-11 flex content-center menu-bar border-2 border-white rounded-full bg-gradient-to-r from-yellow-400 via-yellow-200 to-yellow-400 backdrop-filter ">
//         <Link
//           to="/"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           Home
//         </Link>
//         <Link
//           to="/chi-siamo"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           Chi siamo
//         </Link>
//         <Link
//           to="/nuova-orchestra"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           Nuova orchestra
//         </Link>
//         <Link
//           to="/wind-ensemble"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           Wind Ensemble
//         </Link>
//         <Link
//           to="/suona-con-noi"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           Suona con noi
//         </Link>
//         <Link
//           to="/concerti"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           Concerti
//         </Link>
//         <Link
//           to="/galleria"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           Galleria
//         </Link>
//         <Link
//           to="/contatti"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           Contatti
//         </Link>
//         <Link
//           to="/partners"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           Partners
//         </Link>
//         <Link
//           to="/privacy"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           Privacy
//         </Link>
//         <Link
//           to="/5X1000"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           5X1000
//         </Link>
//         <a
//           href="https://www.facebook.com/profile.php?id=61553129543902"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           {/* Facebook */}
//           <img src={Facebook} className="w-5 h-5 inline-flex" />
//         </a>
//         <a
//           href="https://www.youtube.com/@MilArteAssociazioneCulturale"
//           className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
//         >
//           <img src={Youtube} className="w-5 h-5 inline-flex" />
//         </a>
//       </nav>

//       <button
//         onClick={toggleSidenav}
//         className=" xl:hidden mt-5 px-4 py-4 rounded-full text-white bg-yellow-500 "
//       >
//         <img src={DLogo} className="w-6" />
//       </button>

//       {/* Sidenav */}
//       <div
//         className={` fixed inset-0 bg-yellow-400 bg-opacity-80 z-50 transition-transform ease-in-out duration-300 transform ${
//           sidenavOpen ? "translate-x-0" : "translate-x-full"
//         }`}
//       >
//         <div className="flex flex-col items-center h-full py-8 justify-around text-2xl">
//           <Link
//             to="/"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//             onClick={toggleSidenav}
//           >
//             Ｈｏｍｅ
//           </Link>
//           <Link
//             to="/chi-siamo"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//             onClick={toggleSidenav}
//           >
//             Ｃｈｉ-ｓｉａｍｏ
//           </Link>
//           <Link
//             to="/nuova-orchestra"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//             onClick={toggleSidenav}
//           >
//             Ｎｕｏｖａ-ｏｒｃｈｅｓｔｒａ
//           </Link>
//           <Link
//             to="/wind-ensemble"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//             onClick={toggleSidenav}
//           >
//             Ｗｉｎｄ-Ｅｎｓｅｍｂｌｅ
//           </Link>
//           <Link
//             to="/suona-con-noi"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//             onClick={toggleSidenav}
//           >
//             Ｓｕｏｎａ-ｃｏｎ-ｎｏｉ
//           </Link>
//           <Link
//             to="/concerti"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//             onClick={toggleSidenav}
//           >
//             Ｃｏｎｃｅｒｔｉ
//           </Link>
//           <Link
//             to="/galleria"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//             onClick={toggleSidenav}
//           >
//             Ｇａｌｌｅｒｉａ
//           </Link>
//           <Link
//             to="/contatti"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//             onClick={toggleSidenav}
//           >
//             Ｃｏｎｔａｔｔｉ
//           </Link>
//           <Link
//             to="/partners"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//             onClick={toggleSidenav}
//           >
//             Ｐａｒｔｎｅｒｓ
//           </Link>
//           <Link
//             to="/privacy"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//             onClick={toggleSidenav}
//           >
//             Ｐｒｉｖａｃｙ
//           </Link>

//           <Link
//             to="/5X1000"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//             onClick={toggleSidenav}
//           >
//             ５Ｘ１０００
//           </Link>
//           <a
//             href="https://www.facebook.com/profile.php?id=61553129543902"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//           >
//             <img src={Facebook} className="w-5 h-5 inline-flex" />
//           </a>
//           <a
//             href="https://www.youtube.com/@MilArteAssociazioneCulturale"
//             className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
//           >
//             <img src={Youtube} className="w-5 h-5 inline-flex" />
//           </a>
//         </div>
//         <button
//           onClick={toggleSidenav}
//           className="absolute top-0 right-0 m-4 text-black text-xl"
//         >
//           X
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Navbar;

import React, { useState } from "react";
import Logo from "../imgs/top-sito.jpg";
import DLogo from "../imgs/dropdown-icon.png";
import Facebook from "../facebook.svg";
import Youtube from "../youtube.svg";

const Navbar = () => {
  const [sidenavOpen, setSidenavOpen] = useState(false);
  const toggleSidenav = () => {
    setSidenavOpen(!sidenavOpen);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="relative flex justify-center items-center">
        <img src={Logo} alt="Logo" className="z-0" />
      </div>

      <a
        href="https://www.facebook.com/profile.php?id=61553129543902"
        className="xs:hidden xl:inline-block absolute xs:top-24 md:top-0 right-0 text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 cursor-pointer whitespace-nowrap z-10"
      >
        <img src={Facebook} className="w-5 h-5 inline-flex" />
      </a>
      <a
        href="https://www.youtube.com/@MilArteAssociazioneCulturale"
        className="xs:hidden xl:inline-block absolute xs:top-24 md:top-0 xs:right-7 md:right-9 text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 cursor-pointer whitespace-nowrap z-10"
      >
        <img src={Youtube} className="w-5 h-5 inline-flex" />
      </a>
      <nav className="xs:hidden xl:inline-block  h-11 flex content-center menu-bar border-2 border-white rounded-full bg-gradient-to-r from-yellow-400 via-yellow-200 to-yellow-400 backdrop-filter ">
        <a
          href="#home"
          className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
        >
          Home
        </a>
        <a
          href="#chi-siamo"
          className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
        >
          Chi siamo
        </a>
        <a
          href="#nuova-orchestra"
          className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
        >
          Nuova orchestra
        </a>
        <a
          href="#wind-ensemble"
          className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
        >
          Wind Ensemble
        </a>
        <a
          href="#Milarte-Fa-Scuola"
          className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
        >
          Milarte Fa Scuola
        </a>
        <a
          href="#suona-con-noi"
          className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
        >
          Suona con noi
        </a>
        <a
          href="#concerti"
          className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
        >
          Concerti
        </a>
        <a
          href="#galleria"
          className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
        >
          Galleria
        </a>
        <a
          href="#contatti"
          className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
        >
          Contatti
        </a>
        <a
          href="#partners"
          className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
        >
          Partners
        </a>
        <a
          href="#privacy"
          className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
        >
          Privacy
        </a>
        <a
          href="#5x1000"
          className="text-white font-semibold text-sm md:text-base px-4 py-2 md:px-6 md:py-3 mx-2 md:mx-4 relative cursor-pointer whitespace-nowrap"
        >
          5X1000
        </a>
      </nav>

      <button
        onClick={toggleSidenav}
        className="xl:hidden mt-5 px-4 py-4 rounded-full text-white bg-yellow-500"
      >
        <img src={DLogo} className="w-6" />
      </button>

      <div
        className={`fixed inset-0 bg-yellow-400 bg-opacity-80 z-50 transition-transform ease-in-out duration-300 transform ${
          sidenavOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col items-center h-full py-8 justify-around text-xl">
          <a
            href="#home"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
            onClick={toggleSidenav}
          >
            Ｈｏｍｅ
          </a>
          <a
            href="#chi-siamo"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
            onClick={toggleSidenav}
          >
            Ｃｈｉ-ｓｉａｍｏ
          </a>
          <a
            href="#nuova-orchestra"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
            onClick={toggleSidenav}
          >
            Ｎｕｏｖａ-ｏｒｃｈｅｓｔｒａ
          </a>
          <a
            href="#wind-ensemble"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
            onClick={toggleSidenav}
          >
            Ｗｉｎｄ-Ｅｎｓｅｍｂｌｅ
          </a>
          <a
            href="#Milarte-Fa-Scuola"
            className=" hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
            onClick={toggleSidenav}
          >
            Ｍｉｌａｒｔｅ－Ｆａ－Ｓｃｕｏｌａ
          </a>
          <a
            href="#suona-con-noi"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
            onClick={toggleSidenav}
          >
            Ｓｕｏｎａ-ｃｏｎ-ｎｏｉ
          </a>
          <a
            href="#concerti"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
            onClick={toggleSidenav}
          >
            Ｃｏｎｃｅｒｔｉ
          </a>
          <a
            href="#galleria"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
            onClick={toggleSidenav}
          >
            Ｇａｌｌｅｒｉａ
          </a>
          <a
            href="#contatti"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
            onClick={toggleSidenav}
          >
            Ｃｏｎｔａｔｔｉ
          </a>
          <a
            href="#partners"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
            onClick={toggleSidenav}
          >
            Ｐａｒｔｎｅｒｓ
          </a>
          <a
            href="#privacy"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
            onClick={toggleSidenav}
          >
            Ｐｒｉｖａｃｙ
          </a>
          <a
            href="#5x1000"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
            onClick={toggleSidenav}
          >
            ５Ｘ１０００
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61553129543902"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
          >
            <img src={Facebook} className="w-5 h-5 inline-flex" />
          </a>
          <a
            href="https://www.youtube.com/@MilArteAssociazioneCulturale"
            className="hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-105"
          >
            <img src={Youtube} className="w-5 h-5 inline-flex" />
          </a>
        </div>
        <button
          onClick={toggleSidenav}
          className="absolute top-0 right-0 m-4 text-black text-xl"
        >
          X
        </button>
      </div>
    </div>
  );
};

export default Navbar;
